import { AxiosInstance } from 'axios'

import { toGsResponse } from '../../goodstack'
import { PartnerConfig } from '../../config/config.types'

import { PublicFundraiserConfig } from '@percent/workplace-giving/api/fundraiser/getPartnerFundraisingConfig/getFundraisingPartnerConfig.types'

export type GetPartnerFundraisingConfigResponse = {
  data: {
    public_fundraisers?: PartnerConfig<'public_fundraisers', PublicFundraiserConfig>
  }
  object: string
}

export const getPartnerFundraisingConfig = async (
  client: AxiosInstance
): Promise<PublicFundraiserConfig | undefined> => {
  const response = await client
    .get<GetPartnerFundraisingConfigResponse>(`v1/partner/fundraising/config`, {
      withCredentials: true,
      validateStatus: code => [200, 404].includes(code)
    })
    .then(r => toGsResponse(r.status, r.data))
    .then(r => (r.result === 'success' ? r : undefined))
    .catch(() => undefined)

  return response?.data.public_fundraisers?.value
}
